function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const BASE_URL = '/user-groups';
class GroupsApiClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getGroups", async ()=>this.get(`${BASE_URL}`)), _define_property(this, "getGroupsByUser", async (userId)=>this.get(`${BASE_URL}/users/${userId}`)), _define_property(this, "getGroupDetail", async (groupId)=>this.get(`${BASE_URL}/${groupId}`)), _define_property(this, "createGroup", async (data)=>this.post(`${BASE_URL}`, data)), _define_property(this, "deactivateGroup", async (payload)=>this.delete(`${BASE_URL}/${payload.groupId}`)), _define_property(this, "updateGroup", async (payload)=>this.put(`${BASE_URL}/${payload.groupId}`, {
                ...payload.data
            })), _define_property(this, "deleteMemberInGroup", async (payload)=>this.put(`${BASE_URL}/${payload.groupId}/delete-group-member`, {
                ...payload.data
            }));
    }
}
export const GroupsApi = new GroupsApiClient();
